// ======================================================
// Lotto Analytics
// Product / Module Configuration
//
// This file is the frontend foundation for:
// Product → Module → Feature
//
// Later this can be replaced / supplemented by API data.
// ======================================================

export const products = [
  {
    key: 'lottery',
    name: 'Lottery',
    status: 'active',

    modules: [
      {
        key: '649',
        name: 'Lotto 6/49',
        path: '/lotto-649',
        status: 'active',
        icon: 'LineChartOutlined',

        features: [
          {
            key: 'basic-analysis',
            name: 'Basic Analysis',
          },
          {
            key: 'advanced-analysis',
            name: 'Advanced Analysis',
          },
          {
            key: 'statistics',
            name: 'Statistics',
          },
        ],
      },

      {
        key: 'max',
        name: 'Lotto MAX',
        path: '/lotto-max',
        status: 'active',
        icon: 'AreaChartOutlined',

        features: [
          {
            key: 'basic-analysis',
            name: 'Basic Analysis',
          },
          {
            key: 'advanced-analysis',
            name: 'Advanced Analysis',
          },
          {
            key: 'statistics',
            name: 'Statistics',
          },
        ],
      },
    ],
  },

  {
    key: 'gaming',
    name: 'Gaming',
    status: 'active',

    modules: [
      {
        key: 'roulette',
        name: 'Roulette',
        path: '/roulette',
        status: 'active',
        icon: 'SafetyCertificateOutlined',

        features: [
          {
            key: 'basic-analysis',
            name: 'Basic Analysis',
          },
          {
            key: 'simulation',
            name: 'Simulation',
          },
          {
            key: 'wheel-offset',
            name: 'Wheel Offset',
          },
          {
            key: 'risk-engine',
            name: 'Risk Engine',
          },
          {
            key: 'circuit-breaker',
            name: 'Circuit Breaker',
          },
          {
            key: 'ai-consultation',
            name: 'AI Consultation',
          },
          {
            key: 'export',
            name: 'Export',
          },
        ],
      },
    ],
  },

  {
    key: 'sports',
    name: 'Sports',
    status: 'coming_soon',

    modules: [
      {
        key: 'nba',
        name: 'NBA',
        path: '/nba',
        status: 'coming_soon',
        features: [],
      },

      {
        key: 'nhl',
        name: 'NHL',
        path: '/nhl',
        status: 'coming_soon',
        features: [],
      },

      {
        key: 'nfl',
        name: 'NFL',
        path: '/nfl',
        status: 'coming_soon',
        features: [],
      },
    ],
  },

  {
    key: 'finance',
    name: 'Finance',
    status: 'coming_soon',

    modules: [
      {
        key: 'market',
        name: 'Market Analytics',
        path: '/finance',
        status: 'coming_soon',
        features: [],
      },
    ],
  },
]


// ======================================================
// Helpers
// ======================================================

export const getAllModules = () => {
  return products.flatMap(
    (product) =>
      product.modules.map(
        (module) => ({
          ...module,
          productKey: product.key,
          productName: product.name,
        })
      )
  )
}


export const getModuleByKey = (key) => {
  return getAllModules().find(
    (module) => module.key === key
  )
}


export const getModuleByPath = (path) => {
  return getAllModules().find(
    (module) => module.path === path
  )
}


export const getFeature = (
  moduleKey,
  featureKey
) => {
  const module =
    getModuleByKey(moduleKey)

  if (!module) {
    return null
  }

  return module.features?.find(
    (feature) =>
      feature.key === featureKey
  ) || null
}